import { IdScene } from "../../features/scenes/types/IdScene";
import { getSceneBackgroundPlayerBase } from "./getSceneBackgroundPlayerBase";
export var mapSceneBackgroundProvider = new Map([
    [IdScene.PlayerBase, getSceneBackgroundPlayerBase],
]);



//////////////////
// WEBPACK FOOTER
// ./src/graphics/backgrounds/mapSceneBackgroundProvider.ts
// module id = 2181
// module chunks = 3